import {
  catchErrorInto,
  effect,
  fromPromise,
  LiveData,
  onComplete,
  onStart,
  Service,
  smartRetry,
} from '@toeverything/infra';
import { EMPTY, exhaustMap, mergeMap } from 'rxjs';

import type { WorkspaceService } from '../../workspace';
import type { WorkspaceTeamsStore } from '../stores/teams';

type TeamResult = {
  id: string;
  name: string;
  parent?: TeamResult | null;
}

export class TeamSearchService extends Service {
  constructor(
    private readonly store: WorkspaceTeamsStore,
    private readonly workspaceService: WorkspaceService
  ) {
    super();
  }

  readonly searchText$ = new LiveData<string>('');
  readonly isLoading$ = new LiveData(false);
  readonly error$ = new LiveData<any>(null);
  readonly result$ = new LiveData<TeamResult[]>([]);

  readonly loadMore = effect(
    exhaustMap(() => {

      return fromPromise(async signal => {
        return this.store.searchByName(
          this.workspaceService.workspace.id,
          this.searchText$.value || undefined,
          signal
        );
      }).pipe(
        mergeMap(data => {
          this.result$.setValue([...this.result$.value, ...data]);
          return EMPTY;
        }),
        smartRetry(),
        catchErrorInto(this.error$),
        onStart(() => {
          this.isLoading$.setValue(true);
        }),
        onComplete(() => this.isLoading$.setValue(false))
      );
    })
  );

  reset() {
    this.result$.setValue([]);
    this.searchText$.setValue('');
    this.error$.setValue(null);
    this.loadMore.reset();
  }

  search(searchText?: string) {
    this.reset();
    this.searchText$.setValue(searchText ?? '');
    this.loadMore();
  }
}
